import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import authImage from "../../assets/images/auth-image.png";
import SectionHeader from "../../components/ui/HeaderSection";
import PlainNavbar from "../../components/layout/PlainNavbar";
import InputField from "../../components/ui/InputField";
import Button from "../../components/ui/Button";
import GoogleButton from "../../components/ui/GoogleButton";
import Toast from "../../components/ui/Toast";

const LoginPage = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [toast, setToast] = useState(null);

  // Fungsi Handle Login
  const handleLogin = async (e) =>   {
    e.preventDefault();

    if (
      email.trim() === "user@example.com" &&
      password.trim() === "password123"
    ) {
      localStorage.setItem("isAuthenticated", "true");
      setToast({ type: "success", message: "Login berhasil! Mengalihkan..." });

      setTimeout(() => {
        navigate("/dashboard/set-theme");
      }, 2000);
    } else {
      setToast({ type: "error", message: "Email atau password salah!" });

      setTimeout(() => {
        setToast(null);
      }, 3000);
    }
  };

  return (
    <>
      <PlainNavbar />
      <div className="flex min-h-screen">
        {/* Gambar di sebelah kiri */}
        <div className="w-2/3 hidden lg:block overflow-hidden h-screen">
          <img
            src={authImage}
            alt="Auth"
            className="w-full h-screen object-cover object-left-top"
          />
        </div>

        {/* Form Login */}
        <div className="w-full lg:w-1/2 flex flex-col justify-start px-10 mt-10">
          {/* Header */}
          <div className="text-left mt-20">
            <SectionHeader
              title="Selamat Datang Kembali"
              description="Silakan masuk untuk melanjutkan perencanaan momen spesial Anda!"
              TitleColor="#010203"
              DescriptionColor="#ABABAB"
              textAlign="left"
            />
          </div>

          {/* Form */}
          <form className="mt-6 space-y-4" onSubmit={handleLogin}>
            <InputField
              title="Email"
              placeholder="Masukkan email Anda"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <InputField
              title="Password"
              placeholder="Masukkan password 8 - 16 karakter"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />

            {/* Remember Me & Forgot Password */}
            <div className="flex justify-between items-center mt-4">
              <label className="flex items-center space-x-2 text-sm text-gray-700">
                <input
                  type="checkbox"
                  className="w-4 h-4 text-blue-500 border-gray-300 rounded focus:ring focus:ring-blue-200"
                />
                <span>Ingat saya</span>
              </label>
              <a
                href="/forgot-password"
                className="text-blue-500 text-sm font-medium"
              >
                Lupa password?
              </a>
            </div>

            {/* Button Login */}
            <div className="mt-3 w-full">
              <Button text="Masuk" fullWidth={true} className="w-full" />
            </div>
          </form>

          {/* Divider */}
          <div className="flex items-center my-4">
            <hr className="flex-grow border-gray-300" />
            <span className="px-2 text-gray-500 text-sm">OR</span>
            <hr className="flex-grow border-gray-300" />
          </div>

          {/* Google Sign-In */}
          <GoogleButton />

          {/* Register Link */}
          <p className="mt-4 pb-6 text-center text-sm text-gray-600">
            Belum Punya Akun?{" "}
            <a href="/register" className="text-blue-500 font-medium">
              Daftar Sekarang
            </a>
          </p>
        </div>
      </div>

      {/* Container Toast (Dibuat Global di Luar Layout) */}
      <div className="fixed top-5 right-5 z-50">
        {toast && (
          <Toast
            type={toast.type}
            message={toast.message}
            onClose={() => setToast(null)}
          />
        )}
      </div>
    </>
  );
};

export default LoginPage;
